// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__9EJLu","title":"Info_title__qPyJC","selects":"Info_selects__DEML-","requiredAsterisk":"Info_requiredAsterisk__3Ud5I"};